<form (ngSubmit)="submit()" [formGroup]="timesliForm">
	<p-stepper [(activeStep)]="activeIndex">
		<p-stepperPanel>
			<ng-template pTemplate="header">
				<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(0)"
					[class]="getColorFirstTab()" 
				>
					<div class="flex flex-row align-items-center justify-content-center">
						<i class="pi cm-info text-2xl pr-2"></i>
						<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'GENERIC_SETTINGS' | translate }}</label>
					</div>
				</button>
			</ng-template>

			<ng-template pTemplate="content" let-nextCallback="nextCallback">
				<div class="grid">
					<div class="col-12" [ngClass]="customPaddingX()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.name, 'borderInput')">
								<input type="text" pInputText
									[ngClass]="dynamicInputTextWidth()"
									formControlName="name"
									autocomplete="customer-name"
									placeholder="{{ 'NAME' | translate }}"
									maxlength="40"
								/>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div class="col-12" [ngClass]="customPaddingX()"> <!-- TYPE_TIMESLICE -->
						<div class="flex justify-content-between flex-wrap" [ngClass]="manageRespStyle('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('label')">{{ 'TYPE_TIMESLICE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('borderInput')">
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="1" formControlName="type" id="1" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'TIMESLOT' | translate" styleClass="p-tag-info"></p-tag>
								</div>
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="2" formControlName="type" id="2" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'SPECIALPERIOD' | translate" styleClass="p-tag-info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12" [ngClass]="customPaddingX()"> <!-- ACCESS_MODE -->
						<div class="flex justify-content-between flex-wrap" [ngClass]="manageRespStyle('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('label')">{{ 'ACCESS_MODE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('borderInput')">
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="0" formControlName="includeExclude" id="0" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'ACCESS_MODE_EXCLUDE' | translate" styleClass="p-tag-info"></p-tag>
								</div>
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="1" formControlName="includeExclude" id="1" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'ACCESS_MODE_INCLUDE' | translate" styleClass="p-tag-info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12" [ngClass]="customPaddingX()" [class]="overTablet() && !isSpecialPeriod() ? 'mb-8' : ''"> <!-- TEMPORARY_BAND -->
						<div class="flex justify-content-between flex-wrap" [ngClass]="manageRespStyle('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('label')">{{ 'TEMPORARY_BAND' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('borderInput')">
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="0" formControlName="temporary" id="0" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'TEMPORARY_BAND_DISABLED' | translate" styleClass="p-tag-info"></p-tag>
								</div>
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="1" formControlName="temporary" id="1" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'TEMPORARY_BAND_ENABLED' | translate" styleClass="p-tag-info"></p-tag>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12" *ngIf="isSpecialPeriod()" [ngClass]="customPaddingX()" [class]="overTablet() && isSpecialPeriod() && isTemporary() ? 'mb-8' : ''"> <!-- REPETITION -->
						<div class="flex justify-content-between flex-wrap" [ngClass]="manageRespStyle('borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('label')">{{ 'REPETITION' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStyle('borderInput')">
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="2" formControlName="repetition" id="2" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'REPETITION_MONTHLY' | translate" styleClass="p-tag-info"></p-tag>
								</div>
								<div class="flex align-items-center justify-content-center ml-3 mt-2">
									<p-radioButton value="3" formControlName="repetition" id="3" class="p-radiobutton-policy mr-2"></p-radioButton>
									<p-tag [value]="'REPETITION_ANNUAL' | translate" styleClass="p-tag-info"></p-tag>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="flex py-3 justify-content-end">
					<!-- [disabled]="!canSwitchTab()" -->
					<p-button label="{{ 'NEXT' | translate }}" icon="pi cm-arrow-right" iconPos="right" severity="primary" (onClick)="changeActiveTabClick(1)" />
				</div>
			</ng-template>
		</p-stepperPanel>

		<p-stepperPanel>
			<ng-template pTemplate="header">
				<button pButton pRipple type="button" class="bg-transparent h-3rem" (click)="changeActiveTabClick(1)"
					[class]="getColorSecondTab()"
				>
					<div class="flex flex-row align-items-center justify-content-center">
						<i class="pi cm-date-time text-2xl pr-2"></i>
						<label *ngIf="!onExtendedMobile()" class="font-medium text-lg">{{ 'DETAILS' | translate }}</label>
					</div>
				</button>
			</ng-template>

			<ng-template pTemplate="content">
				<div class="grid">
					<!-- DAYS LIST, TIMESLICE-->
					<div class="col-12" *ngIf="!isSpecialPeriod()" [ngClass]="customPaddingX()">
						<ng-container formArrayName="weekDays">
							<div class="flex justify-content-between flex-wrap" [ngClass]="manageRespStylewithError(this.f.weekDays, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStylewithError(this.f.weekDays, 'label')">{{ 'WEEK_DAYS' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="manageRespStylewithError(this.f.weekDays, 'borderInput')">
									<p-checkbox *ngFor="let day of daysOfWeek" [formControlName]="day.Value" [binary]="true"
													label="{{ day.Name | translate }}" [class]="showErrorRequiredCheckBox(this.f.weekDays)"
													class="ml-4 mt-2"
													[class]="showErrorRequiredCheckBox(this.f.weekDays)">
									</p-checkbox>
								</div>
							</div>
							<small *ngIf="showErrorRequiredMessage(this.f.weekDays)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'WEEK_DAYS_REQUIRE' | translate }}</small>
						</ng-container>
					</div>

					<!-- DAY OF MONTH, SPECIAL PERIOD, MONTH -->
					<div class="col-12 flex justify-content-center text-center" *ngIf="isSpecialPeriod() && !isRepetitionAnnual()">
						<label>{{ 'MONTH_HELP' | translate }}</label>
					</div>
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium" *ngIf="isSpecialPeriod() && !isRepetitionAnnual()">
						{{ 'DAY_MONTH' | translate }}
					</div>
					<div [ngClass]="col6Responsive()" class="pt-2 sm:pt-3" *ngIf="isSpecialPeriod() && !isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.dayMonthStart, 'borderRow')">
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.dayMonthStart, 'label')">{{ 'DAY_MONTH_START' | translate }}</div>
								<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.dayMonthStart, 'borderInput')">
									<p-dropdown [options]="dayMonthList"
										[ngClass]="dynamicInputTextWidth()" appendTo="body"
										styleClass="{{ dynamicInputTextWidth() }} align-items-center"
										formControlName="dayMonthStart">
									</p-dropdown>
								</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.dayMonthStart)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col6Responsive()" class="pt-2 sm:pt-3" *ngIf="isSpecialPeriod() && !isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.dayMonthEnd, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.dayMonthEnd, 'label')">{{ 'DAY_MONTH_END' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.dayMonthEnd, 'borderInput')">
								<p-dropdown [options]="dayMonthList"
									[ngClass]="dynamicInputTextWidth()" appendTo="body"
									styleClass="{{ dynamicInputTextWidth() }} align-items-center"
									formControlName="dayMonthEnd">
								</p-dropdown>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.dayMonthEnd)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>

					<!-- DATE, SPECIAL PERIOD, YEAR-->
					<div class="col-12 flex justify-content-center text-center" *ngIf="isSpecialPeriod() && isRepetitionAnnual()">
						<label>{{ 'YEAR_HELP' | translate }}</label>
					</div>
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium" *ngIf="isSpecialPeriod() && isRepetitionAnnual()">
						{{ 'DAY_AND_MONTH' | translate }}
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon"
								formControlName="startDate" appendTo="body"
								placeholder="dd/mm/yyyy"
								[defaultDate]="today" dateFormat="dd/mm"
								[ngClass]="dynamicInputTextWidth()"
								[styleClass]="dynamicInputTextWidth()"
								inputStyleClass="pl-5 border-noround-right"
								[panelStyleClass]="dynamicDatepicker()">
							</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>

					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
							<p-calendar [showIcon]="true" inputId="icon"
								formControlName="endDate" appendTo="body"
								placeholder="dd/mm/yyyy"
								[defaultDate]="today" dateFormat="dd/mm"
								[ngClass]="dynamicInputTextWidth()"
								[styleClass]="dynamicInputTextWidth()"
								inputStyleClass="pl-5 border-noround-right"
								panelStyleClass="{{ dynamicDatepicker() }}">
							</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ getErrorMessage(this.f.endDate) }}</small>
					</div>

					<!-- TIME, ALWAYS-->
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium">
						{{ 'TIME' | translate }}
					</div>
					<div [ngClass]="col6Responsive()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.startTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startTime, 'label')">{{ 'START_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="startTime" appendTo="body" timeOnly="true"
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									>
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.startTime)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col6Responsive()" [class]="endTimeMarginBottom()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endTime, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endTime, 'label')">{{ 'END_TIME' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endTime, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="endTime" appendTo="body" timeOnly="true"
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									>
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.endTime)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ getErrorMessage(this.f.endTime) }}</small>
					</div>

					<!-- DATE, TIMESLICE, TEMPORARY-->
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium" *ngIf="!isSpecialPeriod() && isTemporary()">
						{{ 'TEMPORARY_BAND' | translate }}
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="!isSpecialPeriod() && isTemporary()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="startDate" appendTo="body"
									placeholder="dd/mm/yyyy"
									[defaultDate]="today" dateFormat="dd/mm/yy"
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="!isSpecialPeriod() && isTemporary()" [class]="overTablet() && !isSpecialPeriod() ? 'mb-6' : ''">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="endDate" appendTo="body"
									placeholder="dd/mm/yyyy"
									[defaultDate]="today" dateFormat="dd/mm/yy"
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ getErrorMessage(this.f.endDate) }}</small>
					</div>
					<!-- DATE, SPECIAL PERIOD, MOUNTH, TEMPORARY-->
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium" *ngIf="isSpecialPeriod() && isTemporary() && !isRepetitionAnnual()">
						{{ 'TEMPORARY_BAND' | translate }}
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isTemporary() && !isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="startDate" appendTo="body"
									placeholder="mm/yyyy"
									[defaultDate]="today" 
									view="month" 
									dateFormat="mm/yy" 
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isTemporary() && !isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="endDate" appendTo="body"
									placeholder="mm/yyyy"
									[defaultDate]="today" 
									view="month" 
									dateFormat="mm/yy" 
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ getErrorMessage(this.f.endDate) }}</small>
					</div>
					<!-- DATE, SPECIAL PERIOD, YEAR, TEMPORARY-->
					<div class="col-12 flex align-items-center justify-content-center text-3xl font-medium" *ngIf="isSpecialPeriod() && isTemporary() && isRepetitionAnnual()">
						{{ 'TEMPORARY_BAND' | translate }}
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isTemporary() && isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.startDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'label')">{{ 'START_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.startDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="startDate" appendTo="body"
									placeholder="yyyy"
									view="year" 
									dateFormat="yy" 
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.startDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
					</div>
					<div [ngClass]="col6Responsive()" *ngIf="isSpecialPeriod() && isTemporary() && isRepetitionAnnual()">
						<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.endDate, 'borderRow')">
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'label')">{{ 'END_DATE' | translate }}</div>
							<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.endDate, 'borderInput')">
								<p-calendar [showIcon]="true" inputId="icon"
									formControlName="endDate" appendTo="body"
									placeholder="yyyy"
									view="year" 
									dateFormat="yy" 
									[ngClass]="dynamicInputTextWidth()"
									[styleClass]="dynamicInputTextWidth()"
									inputStyleClass="pl-5 border-noround-right"
									panelStyleClass="{{ dynamicDatepicker() }}">
								</p-calendar>
							</div>
						</div>
						<small *ngIf="showErrorRequiredMessage(this.f.endDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ getErrorMessage(this.f.endDate) }}</small>
					</div>
				</div>

				<div class="flex py-3 justify-content-between">
					<p-button label="{{ 'BACK' | translate }}" icon="pi cm-arrow-left" iconPos="left" severity="secondary" (onClick)="changeActiveTabClick(0)" />
				</div>
			</ng-template>
		</p-stepperPanel>

		<ng-template pTemplate="end">
			<div class="grid mt-2 mx-1 flex justify-content-center align-items-center">
				<button *ngIf="enableConfirmButtons()" type="submit" pButton pRipple
						label="{{ 'CONFIRM' | translate }}"
						class="p-button-primary text-xl font-normal mx-1 mb-2"
						[ngClass]="dynamicButtonWidth()">
				</button>
				<button type="button" pButton pRipple (click)="closeDialog()"
						label="{{ 'CLOSE' | translate }}"
						class="p-button-secondary text-xl font-normal mx-1 mb-2"
						[ngClass]="dynamicButtonWidth()">
				</button>
			</div>
		</ng-template>
	
	</p-stepper>
</form>